import { Box, Typography } from '@mui/material';
import { useRouter } from 'next/router';

import { AppRoutes } from '@utils/appRoutes';
import useAuth from '@utils/useAuth';
import Footer from '@components/Footer';
import Header from '@components/Header';
import CuminButton from '@components/Button';
import ExitIntent from '@components/ExitIntent';
import PlanBanner from '@components/PlanBanner';

import MiddleSection from './MiddleSection';
import CoFounderSection from './CoFounderSection';
import MeetOurTeam from './MeetOurTeam';
import { headerContent } from './constant';
import { useStyles } from './useStyles';

const OurStoryPage = () => {
  const classes = useStyles();
  const router = useRouter();
  const { detectedCountryCode: countryCode } = useAuth();

  const onStartSubscription = () => {
    router.push(`/${countryCode}${AppRoutes.ORDER_STEP_ONE}`);
  };
  return (
    <>
      {/* <ExitIntent /> */}
      <Box className={classes.headerContainer}>
        <Header isBackground={false} />
      </Box>
      <Box className={classes.titleDescriptionContainer}>
        <Box className={classes.title}>
          <Typography
            variant="h1"
            align="center"
            color="whitePepper.main"
            maxWidth="730px"
          >
            {headerContent.title}
          </Typography>
        </Box>
        <Box className={classes.description}>
          <Typography
            variant="body1"
            align="center"
            color="garamMasala.main"
            maxWidth="710px"
            mb={3.75}
          >
            {headerContent.firstDescription}
          </Typography>
          <Typography
            variant="body1"
            align="center"
            color="garamMasala.main"
            maxWidth="710px"
          >
            {headerContent.secondDescription}
          </Typography>
        </Box>
      </Box>
      <MiddleSection />
      <MeetOurTeam />
      <CoFounderSection />
      <Box className={classes.planBannerWrapper}>
        <PlanBanner isTitleOnMobile={false} isSmallPadding />
      </Box>
      <Box className={classes.joinUs}>
        <Typography
          variant="h1"
          align="center"
          color="whitePepper.main"
          className={classes.joinUsTitle}
        >
          Join us for a meal!
        </Typography>
        <Box className={classes.startSubscriptionBtnWrapper}>
          <CuminButton
            color="cinnamon"
            variant="contained"
            textColor="whitePepper.main"
            className={classes.startSubscriptionBtn}
            onClick={onStartSubscription}
          >
            Start a Subscription
          </CuminButton>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default OurStoryPage;
